/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Use_Embedded_ActivitiesInputs */



/**
* | output |
* | --- |
* | "Use Activities" |
*
* @param {Leveling_Perm_Use_Embedded_ActivitiesInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_use_embedded_activities = /** @type {((inputs?: Leveling_Perm_Use_Embedded_ActivitiesInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Use_Embedded_ActivitiesInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Использовать активности")
	return /** @type {LocalizedString} */ ("Use Activities")
});